import "./index.less";
import React from "react";
import tool from "../../../api/tool";
class Preview extends React.Component {
  render() {
    let data = tool.get("submitData");
    return (
      <div className="propsal-preview-cont">
        <div className="title-center">
          <span style={{ color: "#000", fontSize: "17px" }}>涉及单位:</span>
          {data && data.complaintOrgCode ? data.complaintOrgCode : ""}
        </div>
        <div className="text-center">
          <span style={{ color: "#000", fontSize: "17px" }}>主要观点:</span>
          <br />
          {data && data.mainAppeal ? data.mainAppeal : ""}
        </div>
        <div className="text-center">
          <span style={{ color: "#000", fontSize: "17px" }}> 具体建议:</span>
          <br />
          {data && data.complaintReason ? data.complaintReason : ""}
        </div>
      </div>
    );
  }
}
export default Preview;
